<template>
  <v-container fluid>
    <hb-loading-indicator v-if="loading" align-middle />

    <v-row justify="center" align="center" no-gutters v-else-if="error">
      <v-col cols="12">
        <div class="text-center pl-5 pr-5" style="padding-bottom: 150px;" :style="{paddingTop: $vuetify.breakpoint.smAndUp ? '200px' : '50px'}">
          <hb-icon size="100" color="grey darken-3">error_outline</hb-icon>
          <div class="headline font-weight-bold mt-3 mb-3">{{ $t('register_kitchen.error_title') }}</div>
          <div class="subtitle-1 grey--text text--lighten-2">{{ errorMessage }}</div>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center" align="start" :class="[$vuetify.breakpoint.xsOnly && 'fill-height']" no-gutters v-else-if="info && !registered">
      <v-col cols="12" md="10" lg="6">
        <v-card>
          <v-responsive>
            <v-img class="black" lazy-src="/img/Keittiökalusteiden_hinta_IMG_4805_thumb.jpg" aspect-ratio="2.290076335877863" src="/img/Keittiökalusteiden_hinta_IMG_4805_main.jpg" :alt="$t('webshop.webshop_image')" />
          </v-responsive>
          <v-card-title class="headline font-weight-bold" style="word-break: break-word;">{{ $t('register_kitchen.title') }}</v-card-title>
          <v-card-subtitle class="accent--text">{{ $t('register_kitchen.subtitle') }}</v-card-subtitle>
          <v-card-text class="mb-3">
            <div>
              <div class="subtitle-1">{{ $t('register_kitchen.you_are_registering_kitchen_in_following_address') }}</div>
              <div class="text--primary title">
                <div> {{ osoite }}
                
                </div>
              </div>
              <div class="mt-1" style="font-style: italic;">{{ $t('register_kitchen.confirm_address') }}</div>
            </div>

            <div class="mt-5">
              <div class="subtitle-1">{{ $t('register_kitchen.kitchen_linked_to_user') }}</div>
              <div class="text--primary title">
                {{ userEmail }}
              </div>
              <div class="mt-1" style="font-style: italic;">
                <span class="mr-2">{{ $t('register_kitchen.confirm_email') }}</span>
                <v-btn style="font-style: normal;" small text @click="logout">{{ $t('logout') }}</v-btn>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" block :loading="registering" @click="doRegister">
              {{ $t('register_kitchen.register_button') }}<hb-icon right >mdi-stove</hb-icon>
            </v-btn>
          </v-card-actions>
          <v-card-text class="caption text-center pt-0">
            {{ $t('register_kitchen.confirm_your_right') }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qrApi from '../api/qrRegistrationApi';
import auth from "@/auth";

export default {
  props: {
    secretKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      registering: false,
      error: false,
      errorMessage: '',
      info: null,
      registered: false,
    };
  },
  async mounted() {
    this.$gaPageView();
    try {
      this.info = await qrApi.getInfo(this.secretKey);
    } catch (e) {
      this.error = true;
      this.errorMessage = this.$t('register_kitchen.invalid_key');
    }
    this.loading = false;
  },
  computed: {
    osoite() {
      const info = this.info;
      if (!info) return '';
      
      return [info.osoite, info.osoite2, info.postinumero, info.postitoimipaikka].filter(Boolean).join(', ');
    },
    userEmail() {
      return this.$user.email;
    },
  },
  methods: {
    async doRegister() {
      this.registering = true;
      try {
        const response = await qrApi.register(this.secretKey);
        this.registered = true;

        await this.$store.dispatch('reloadProjects');

        const newAddress = this.$store.state.userProjects?.find(a => a.id === response.kohdenro);
        this.$store.commit('setSelectedAddress', response.kohdenro);
        if (newAddress) {
          this.$store.commit('setSelectedAddressRole', newAddress.role);
        }

        this.$router.push({
          name: 'dashboard',
          params: { addressId: response.kohdenro },
        });
        this.$showSuccessNotification(this.$t('register_kitchen.register_success'));
      } catch (e) {
        this.$showErrorNotification(this.$t('register_kitchen.error'));
        this.registering = false;
      }
    },
    logout() {
      auth.client.logout();
    },
  },
};
</script>
